'use strict';

export default class QuickFacts {
  constructor() {
    if($('body.sfPageEditor').length == 0 ) {
      var $el = $(".quick-facts__item-number"); //[make sure this is a unique variable name]

      function isElementInViewport (el) {

          //special bonus for those using jQuery
          if (typeof jQuery === "function" && el instanceof jQuery) {
              el = el[0];
          }

          var rect = el.getBoundingClientRect();

          return (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
              rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
          );
      }

      if( $el.length ) {

        var animateNumbers = false;
        $(".quick-facts__item-number").css('opacity','0');

        $(window).on('DOMContentLoaded load resize scroll', function(){
          var visible = isElementInViewport(document.querySelector(".quick-facts"));

          if(visible && !animateNumbers){
            animateDigits();
            animateNumbers = true;
          }
        });

        var animateDigits = function(){
          var number = $(".quick-facts__item-number").text();

          $(".quick-facts__item-number").css('opacity','1');


          $el.each(function(i, item){

            var value = $(item).text();

            var valueNoCommas = value.replace(',','');

            var digits = valueNoCommas.replace(/\D/g,'');
            var word = valueNoCommas.replace(digits,'');

            $(item).animate({someValue: digits}, {
                duration: 1000,
                easing:'swing', // can be anything
                step: function() { // called on every step
                  $(item).text(commaSeparateNumber(Math.round(this.someValue), word));
                }
            });
          })

          function commaSeparateNumber(val, word){
             while (/(\d+)(\d{3})/.test(val.toString())){
               val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
             }
             if(word[0] === '$') {
               return '$' + val + word.substring(1,word.length);
             } else {
               return val + word;
             }

           }
        }


      }

    }

  }
}
